<template>
  <sections-extra-layout>
    <template slot="title">Audience</template>
    <template slot="description">Define who should see the {{ type }}.</template>
    <template slot="content">
      <div id="Audience">
        <div>
          <p v-if="isCsv" class="mb-2 ">
            <span class="material-symbols-outlined align-middle text-base">
              info
            </span>This is a csv {{ type }}, you can't change audience.
          </p>
          <p class="font-bold mb-4">Who should see this content?</p>
          <div class="mt-2">
            <label class=" cursor-pointer w-full mb-4 inline-flex items-center ml-6">
              <input @change="emitTargetAudience()" v-model="fields.target_audience" type="radio" class="form-radio" name="target_audience" value="all">
              <span class="ml-2">All users</span>
            </label>

            <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6">
              <input @change="emitTargetAudience()" v-model="fields.target_audience" type="radio" class="form-radio" name="target_audience" value="bubbles">
              <span class="ml-2">Users from each Bubbles</span>
            </label>

            <div
              v-if="fields.target_audience === 'bubbles'"
              class="ml-12">
              <div class="border rounded border-gray-300 p-2">

                <button
                  v-for="bubble in fields.target_bubbles" :key="bubble.id"
                  @click="bubbleIdToEdit = bubble.id; openBubbleCreation = true" class="mb-2 bg-gray-200 border border-gray-200 rounded text-gray-600 mr-2 inline-flex">
                  <span class="p-2">{{ bubble.name }}</span>
                  <span class="p-2 bg-white">{{bubble.usercount}}</span>
                </button>

                <button class="px-4 py-2 rounded border border-gray-200 text-gray-500 max-w-max shadow-sm hover:shadow-md mr-3" @click="openBubbleChoice = true">+ Add Bubble</button>
              </div>
              <span v-if="fields.target_bubbles.length === 0">
                <p class="font-bold text-red-500">You need to select at least one bubble.</p>
              </span>
            </div>
          </div>
        </div>

        <div>
          <p class="font-bold mb-4">Who should not see this content?</p>
          <div class="mt-2">
            <label class=" cursor-pointer w-full mb-4 inline-flex items-center ml-6">
              <input @change="emitExcludedAudience()" v-model="fields.excluded_audience" type="radio" class="form-radio" name="excluded_audience" value="no-one">
              <span class="ml-2">No one is excluded</span>
            </label>

            <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6">
              <input @change="emitExcludedAudience()" v-model="fields.excluded_audience" type="radio" class="form-radio" name="excluded_audience" value="bubbles">
              <span class="ml-2">Users from each Bubbles</span>
            </label>

            <div
              v-if="fields.excluded_audience === 'bubbles'"
              class="ml-12">
              <div class="border rounded border-gray-300 p-2">
                <button
                  v-for="bubble in fields.excluded_bubbles" :key="bubble.id"
                  @click="bubbleIdToEdit = bubble.id; openExcludedBubbleCreation = true" class="mb-2 bg-gray-200 border border-gray-200 rounded text-gray-600 mr-2 inline-flex">
                  <span class="p-2">{{ bubble.name }}</span>
                  <span class="p-2 bg-white">{{bubble.usercount}}</span>
                </button>

                <button class="px-4 py-2 rounded border border-gray-200 text-gray-500 max-w-max shadow-sm hover:shadow-md mr-3" @click="openExcludedBubbleChoice = true">+ Add Bubble</button>
              </div>
              <span v-if="fields.excluded_bubbles.length === 0">
                <p class="font-bold text-red-500">You need to select at least one bubble.</p>
              </span>
            </div>
          </div>
        </div>
      </div>

      <banners-ui-sidebar-bubble-selector
        v-if="openBubbleChoice"
        :excluded-bubbles="fields.target_bubbles.map(b => b.id)"
        @bubble="chooseBubble"
        @close="() => {openBubbleChoice = false}"/>

      <banners-ui-sidebar-bubble-selector
        v-if="openExcludedBubbleChoice"
        :excluded-bubbles="fields.excluded_bubbles.map(b => b.id)"
        @bubble="chooseExcludedBubble"
        @close="() => {openExcludedBubbleChoice = false}"/>

      <bubbles-ui-sidebar-create
        v-if="openBubbleCreation"
        @created-bubble="addBubbleToList"
        :bubble-id="bubbleIdToEdit"
        :enable-unlink="true && !!fields.target_bubbles.find(b => {return b.id === bubbleIdToEdit})"
        @unlink="unlinkBubble"
        @close="() => {openBubbleCreation = false}"
      />

      <bubbles-ui-sidebar-create
        v-if="openExcludedBubbleCreation"
        @created-bubble="addExcludeBubbleToList"
        :bubble-id="bubbleIdToEdit"
        :enable-unlink="true && !!fields.excluded_bubbles.find(b => {return b.id === bubbleIdToEdit})"
        @unlink="unlinkExcludeBubble"
        @close="() => {openExcludedBubbleCreation = false}"
      />

    </template>
  </sections-extra-layout>
</template>

<script>

export default {
  name: 'Audience',
  props: {
    type: {
      type: String,
      required: true
    },
    targetAudience: {
      type: String
    },
    excludedAudience: {
      type: String
    },
    bubbles: {
      type: Array
    },
    excludedBubbles: {
      type: Array
    },
    isCsv: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      fields: {
        target_audience: null,
        target_bubbles: [],

        excluded_audience: null,
        excluded_bubbles: []
      },
      bubbleIdToEdit: null,
      openBubbleChoice: false,
      openBubbleCreation: false,

      openExcludedBubbleChoice: false,
      openExcludedBubbleCreation: false,
    }
  },
  methods: {
    componentUpdated (element, disable) {
      const tags = ["button", "input", "textarea", "select"];
      tags.forEach(tagName => {
        if(element) {
          const nodes = element.getElementsByTagName(tagName);
          for (let i = 0; i < nodes.length; i++) {
            nodes[i].disabled = disable;
            if (disable) {
              nodes[i].classList.add("cursor-not-allowed")
              nodes[i].title = `This is a csv ${this.type}, you can't change audience.`
            }
          }
        }
      });
    },

    chooseBubble (bubbleId) {
      this.bubbleIdToEdit = bubbleId
      this.openBubbleChoice = false
      this.openBubbleCreation = true
    },

    chooseExcludedBubble (bubbleId) {
      this.bubbleIdToEdit = bubbleId
      this.openExcludedBubbleChoice = false
      this.openExcludedBubbleCreation = true
    },

    unlinkBubble (bubbleIdToUnlink) {
      let bubbles = this.bubbles.filter(bubble => { return bubble.id !== bubbleIdToUnlink })
      this.fields.target_bubbles = bubbles
      this.$emit('erase-bubble', bubbles)
      this.openBubbleChoice = false
      this.openBubbleCreation = false
    },

    unlinkExcludeBubble (bubbleIdToUnlink) {
      let bubbles = this.excludedBubbles.filter(bubble => { return bubble.id !== bubbleIdToUnlink })
      this.fields.excluded_bubbles = bubbles
      this.$emit('erase-excluded-bubble', bubbles)
      this.openExcludedBubbleChoice = false
      this.openExcludedBubbleCreation = false
    },

    addBubbleToList (bubble) {
      this.fields.target_bubbles = this.fields.target_bubbles.filter(b => b.id !== bubble.id)

      this.fields.target_bubbles.push(bubble)

      this.$emit('update-bubbles', bubble)
    },

    addExcludeBubbleToList (bubble) {
      this.fields.excluded_bubbles = this.fields.excluded_bubbles.filter(b => b.id !== bubble.id)

      this.fields.excluded_bubbles.push(bubble)

      this.$emit('update-excluded-bubbles', bubble)
    },

    emitTargetAudience () {
      if (this.fields.target_audience === 'all') {
        this.fields.target_bubbles = []
        this.$emit('update-bubbles', []);
      }
      this.$emit('update-audience', this.fields.target_audience)
    },

    emitExcludedAudience () {
      if (this.fields.excluded_audience === 'no-one') {
        this.fields.excluded_bubbles = []
        this.$emit('update-excluded-bubbles', [])
      }
      this.$emit('update-excluded-audience', this.fields.excluded_audience)
    }
  },
  mounted () {
    this.fields.target_audience = this.targetAudience ? this.targetAudience : 'all'
    this.fields.target_bubbles = this.bubbles ? this.bubbles : []
    if (this.fields.target_audience === 'bubbles' && this.fields.target_bubbles.length === 0) {
      this.fields.target_audience = 'all'
    }

    this.fields.excluded_audience = this.excludedAudience ? this.excludedAudience : 'no-one'
    this.fields.excluded_bubbles = this.excludedBubbles ? this.excludedBubbles : []
    if (this.fields.excluded_audience === 'bubbles' && this.fields.excluded_bubbles.length === 0) {
      this.fields.excluded_audience = 'no-one'
    }
    if (this.isCsv) {
      setTimeout(() => {
        this.componentUpdated(document.getElementById("Audience"), true)
      }, 100)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ui/form/audience.vue